import { postReq } from '../../api';

export const getAllCourses = (data, cb) => {
  postReq('/webapi/student/course/get/all', data, '', cb);
};
